// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyC3a8jORneKsPgtu46FEs3SI2o3VTCT4Qo",
    authDomain: "goaapp-test.firebaseapp.com",
    databaseURL: "https://goaapp-test.firebaseio.com",
    projectId: "goaapp-test",
    storageBucket: "goaapp-test.appspot.com",
    messagingSenderId: "484453362588"
  }
};



// WEBPACK FOOTER //
// C:/Users/Administrator/Desktop/Hotel-Data/src/environments/environment.ts